var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#EE3465;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,117c31.5,0,57-25.5,57-57S91.5,3,60,3S3,28.5,3,60S28.5,117,60,117z M60,120c33.1,0,60-26.9,60-60 S93.1,0,60,0S0,26.9,0,60S26.9,120,60,120z M55.1,60.7L36.7,42.3l5.7-5.7l18.4,18.4l17.7-17.7L84,43L66.4,60.7l17,17l-5.7,5.7 l-17-17L43,84l-5.7-5.7L55.1,60.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsuccess);
export default __webpack_public_path__ + "static/media/unsuccess.d891f940816430cc906df2578677c2e1.svg";
export { ForwardRef as ReactComponent };